module.exports = __webpack_public_path__ + "img/baseline-close-24px.777b93c6.svg";